import isExternalHref from "@casino/shared/utils/router/isExternalHref";
import type SharedLinkProps from "../../SharedLinkProps";

const patchHrefLocale = ({
  href,
  language,
  defaultLang,
}: Pick<SharedLinkProps, "href" | "language" | "defaultLang">) => {
  const isDefaultLang = language === defaultLang;
  if (href instanceof Object) {
    if (!isDefaultLang && href.pathname) {
      return {
        ...href,
        pathname: addLanguageToPathname(language, href.pathname),
      };
    }
    return href;
  }
  if (isExternalHref(href)) {
    return href;
  }
  return isDefaultLang ? href : addLanguageToPathname(language, href);
};

const addLanguageToPathname = (language: string, pathname: string) =>
  `/${language}${pathname}`;

export default patchHrefLocale;
